import { defineApiActionTypes } from 'store/common/action-helpers';

const prefix = 'features/admin/companies/advisors';

export const FETCH_COMPANY_ADVISOR_CONNECTIONS_FOR_ADMIN_BY_PRETTY_ID = defineApiActionTypes(
  `${prefix}/FETCH_CONNECTIONS_FOR_ADMIN_BY_PRETTY_ID`
);

export const INVITE_ADVISOR_TO_COMPANY = defineApiActionTypes(`${prefix}/INVITE`);

export const DELETE_ADVISOR_FROM_COMPANY = defineApiActionTypes(`${prefix}/DELETE`);

export const UPDATE_SOFT_CONNECTION_STATUS = defineApiActionTypes(
  `${prefix}/UPDATE_SOFT_CONNECTION_STATUS`
);

export const UPDATE_ADVISOR_TO_COMPANY = defineApiActionTypes(`${prefix}/UPDATE`);



// WEBPACK FOOTER //
// ./src/store/features/admin/companies/advisors/action-types.js